'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { useState } from 'react';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { TDynamicData } from '../../types/dynamic-data';

import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../shared/heading';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';

export const Certificates = ({
  certificates,
  title,
}: {
  certificates: TDynamicData[];
  title: string;
}) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any[], index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <section className={cn('custom-section', 'gap-12')}>
        <Heading
          title={title}
          className={{ line: 'hidden', container: 'items-center justify-center text-center' }}
        />
        <div
          className={cn('custom-container', 'grid grid-cols-3 gap-2.5 sm:gap-4 md:gap-8 lg:gap-12')}
        >
          {certificates.map((certificate, index) => (
            <Image
              key={certificate.name}
              src={certificate.image.url}
              alt={resolveImageAlt(certificate?.image, certificate?.name)}
              onClick={handleOpenGallery(
                certificates.map(certificate => certificate.image),
                index,
              )}
              height={0}
              width={0}
              className="col-span-1 h-auto w-full object-contain object-center"
              sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 33vw"
            />
          ))}
        </div>
      </section>
    </>
  );
};
